import { Box, Button, Card, CardContent, Grid, Snackbar, Typography } from "@mui/material";
import React, { useState } from "react";
import { returnNetwork } from "../../utils/NetworkFunctions.js";
import { getDecimalsByCrypto } from "../../utils/cryptoCurrenciesUtils.js";

const RequestResume = ({ cryptoCurrency, network, title, withdrawal }) => {
	const [open, setOpen] = useState(false);

	const handleCopy = (text) => {
		navigator.clipboard
			.writeText(text)
			.then(() => {
				setOpen(true);
			})
			.catch((err) => {
				console.error("Failed to copy text: ", err);
			});
	};

	return (
		<Grid container spacing={2} sx={{ justifyContent: "center", textAlign: "center" }}>
			<Grid size={{ xs: 12, sm: 12, md: 12 }}>
				<Card sx={{ maxWidth: 500, minWidth: 500 }}>
					<CardContent>
						<Box sx={{ marginTop: 2 }}>
							<Typography sx={{ fontSize: "24px", fontWeight: "bold" }} gutterBottom>
								{title}
							</Typography>
						</Box>
						<Box sx={{ marginTop: 2 }}>
							<Typography color="#0560FB" sx={{ fontSize: "18px", fontWeight: "bold" }} gutterBottom>
								{`${cryptoCurrency} ${returnNetwork(network, cryptoCurrency)} Network`}
							</Typography>
						</Box>
						<Box sx={{ marginTop: 2 }}>
							<Typography sx={{ fontSize: "22px", fontWeight: "bold", color: "#008000" }} gutterBottom>
								{`Transaction Sent`}
							</Typography>
						</Box>
						<Box sx={{ textAlign: "center", marginTop: 2, paddingLeft: 3, paddingRight: 3 }}>
							<Typography sx={{ fontSize: "22px", fontWeight: "bold", color: "#008000" }} gutterBottom>
								{`$${parseFloat(withdrawal.currencyAmount).toFixed(2)}`}
							</Typography>
						</Box>
						<Box sx={{ textAlign: "left", marginTop: 2, paddingLeft: 3, paddingRight: 3 }}>
							<Typography sx={{ fontSize: "10px", fontWeight: "bold" }} gutterBottom>
								{`Transaction Id`}
							</Typography>
							<Typography sx={{ fontSize: "10px", fontWeight: "bold" }} gutterBottom>
								{`${withdrawal.txid_hash}`}
							</Typography>
						</Box>
						<Box sx={{ textAlign: "center" }}>
							<Button
								sx={{ borderRadius: 6, fontSize: "12px", backgroundColor: "#444343", color: "white", marginTop: 2, height: "25px" }}
								size="small"
								onClick={() => handleCopy(withdrawal.txid_hash)}
							>
								Copy
							</Button>
							<Snackbar open={open} onClose={() => setOpen(false)} autoHideDuration={2000} message="Copied to clipboard" />
						</Box>
						<Box sx={{ textAlign: "justify", marginTop: 2, paddingLeft: 3, paddingRight: 3 }}>
							<Grid container>
								<Grid size={6}>
									<Typography sx={{ fontSize: "14px", fontWeight: "bold", color: "333333" }} gutterBottom>
										{`Crypto Amount`}
									</Typography>
								</Grid>
								<Grid size={6} sx={{ textAlign: "right" }}>
									<Typography sx={{ fontSize: "14px", fontWeight: "bold", color: "333333" }} gutterBottom>
										{`${parseFloat(withdrawal.cryptoAmount).toFixed(getDecimalsByCrypto(cryptoCurrency))}`}
									</Typography>
								</Grid>
							</Grid>
						</Box>
						<Box sx={{ textAlign: "justify", paddingLeft: 3, paddingRight: 3 }}>
							<Grid container>
								<Grid size={6}>
									<Typography sx={{ fontSize: "14px", fontWeight: "bold", color: "333333" }} gutterBottom>
										{`Exchange`}
									</Typography>
								</Grid>
								<Grid size={6} sx={{ textAlign: "right" }}>
									<Typography sx={{ fontSize: "14px", fontWeight: "bold", color: "333333" }} gutterBottom>
										{`${parseFloat(withdrawal.exchangeRate).toFixed(2)}`}
									</Typography>
								</Grid>
							</Grid>
						</Box>
						<Box sx={{ textAlign: "justify", paddingLeft: 3, paddingRight: 3, paddingBottom: 5 }}>
							<Grid container>
								<Grid size={6}>
									<Typography sx={{ fontSize: "14px", fontWeight: "bold", color: "333333" }} gutterBottom>
										{`Withdrawal Total`}
									</Typography>
								</Grid>
								<Grid size={6} sx={{ textAlign: "right" }}>
									<Typography sx={{ fontSize: "14px", fontWeight: "bold", color: "333333" }} gutterBottom>
										{`${parseFloat(withdrawal.currencyAmount).toFixed(2)}`}
									</Typography>
								</Grid>
							</Grid>
						</Box>
					</CardContent>
				</Card>
			</Grid>
		</Grid>
	);
};

export default RequestResume;
